import { Reveal, Chapter, Hairline } from "./Reveal";

const STATS = [
  { value: "20+", label: "Years in the saddle" },
  { value: "GP", label: "Partially trained under a German Grand Prix rider" },
  { value: "All", label: "Breeds — Coldblood drafts to Purebred Arabians" },
  { value: "Any", label: "Temperament — including challenging stallions" },
];

const About = () => (
  <section id="trainer" data-testid="about-section" className="relative bg-charcoal py-28 lg:py-36">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="grid gap-16 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <Reveal>
              <Chapter number="02" title="The Trainer" testId="about-chapter" />
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-8 font-serif text-4xl font-light leading-tight tracking-tight text-offwhite md:text-5xl">
                Kiara <em className="italic text-gold">Samson</em>
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-6 text-xs uppercase tracking-[0.3em] text-champagne">
                Born &amp; raised in Germany · Now in Dubai
              </p>
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-7">
          <Reveal delay={0.15}>
            <p className="text-lg font-light leading-relaxed text-cream/75 md:text-xl">
              Kiara began riding almost before she could walk. At twenty-six,
              she brings more than two decades in the saddle — and years spent
              as a riding instructor and horse trainer in Germany, where she
              was partially trained under a German Grand Prix dressage rider.
            </p>
          </Reveal>
          <Reveal delay={0.25}>
            <p className="mt-8 text-base font-light leading-relaxed text-cream/60 md:text-lg">
              Her gift is range. She has backed youngsters taking their first
              rider and refined horses in their ridden work; she has
              worked heavy Coldblood drafts and hot Purebred Arabians, and is
              sought out for the horses others find difficult — stallions
              included. She has show jumping miles in her past too, but
              dressage is her home discipline — and she will tell you that
              every good show jumping career begins with a solid dressage
              foundation. This year she relocated to Dubai, bringing the German
              school directly to private stables across the city.
            </p>
          </Reveal>

          <div className="mt-14 grid grid-cols-1 gap-px bg-champagne/15 sm:grid-cols-2">
            {STATS.map((s, i) => (
              <Reveal key={i} delay={0.1 + i * 0.1}>
                <div
                  data-testid={`about-stat-${i + 1}`}
                  className="group h-full bg-charcoal p-8 transition-colors duration-500 hover:bg-ebony"
                >
                  <span className="font-serif text-5xl font-light italic text-gold">
                    {s.value}
                  </span>
                  <p className="mt-4 text-sm font-light leading-relaxed text-cream/55">
                    {s.label}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.3}>
            <Hairline className="mt-14" />
            <p className="mt-8 font-serif text-2xl font-light italic leading-snug text-cream/80 md:text-3xl">
              “A horse does not care for force. It answers only to feel,
              timing — and patience.”
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default About;
